import { render, staticRenderFns } from "./SelectDeprecationMaterials.html?vue&type=template&id=199790ea&scoped=true&external"
import script from "./SelectDeprecationMaterials.ts?vue&type=script&lang=ts&external"
export * from "./SelectDeprecationMaterials.ts?vue&type=script&lang=ts&external"
import style0 from "./SelectDeprecationMaterials.scss?vue&type=style&index=0&id=199790ea&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199790ea",
  null
  
)

export default component.exports